import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { discoveryPlaylistInitialState } from './contant';
import { fetchDiscoveryPlaylists } from './thunks';

const discoverySlice = createSlice({
  name: 'discoveryPlaylists',
  initialState: discoveryPlaylistInitialState,
  reducers: {
    setLastCoverPosition: (state, action: PayloadAction<string>) => {
      state.position.lastCoverPostion = action.payload;
    },
    resetPosition: (state) => {
      state.position = discoveryPlaylistInitialState.position;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchDiscoveryPlaylists.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchDiscoveryPlaylists.rejected, (state) => {
      state.error = true;
    });
    builder.addCase(fetchDiscoveryPlaylists.fulfilled, (state, action) => {
      state.loading = false;
      state.error = false;
      state.data = action.payload;
    });
  },
});

export const { setLastCoverPosition, resetPosition } = discoverySlice.actions;

export default discoverySlice.reducer;
